<template>
    <page>
        <module :title="title">
            <c-form ref="editForm">
                <c-form title="基础信息">
                    <c-form-column>
                        <c-form-item type="video" label="视频" name="video" required file-word="建议尺寸：16：9或4：3"></c-form-item>
                        <c-form-item type="textarea" label="简介" name="remark" required></c-form-item>
                    </c-form-column>
                </c-form>
                <c-form title="技术实力">
                    <c-form-column>
                        <c-form-item type="input" label="研发产品种类" name="product_count" required></c-form-item>
                        <c-form-item type="input" label="研发产品种类(单位)" name="product_count_unit" required></c-form-item>
                        <c-form-item type="input" label="生产能力" name="production_capacity" required></c-form-item>
                        <c-form-item type="input" label="生产能力(单位)" name="production_capacity_unit" required></c-form-item>
                        <c-form-item type="input" label="标准溶液制备能力" name="preparation_capacity" required></c-form-item>
                        <c-form-item type="input" label="标准溶液制备能力(单位)" name="preparation_capacity_unit" required></c-form-item>
                        <c-form-item type="input" label="申请发明专利" name="patent_count" required></c-form-item>
                        <c-form-item type="input" label="申请发明专利(单位)" name="patent_count_unit" required></c-form-item>
                    </c-form-column>
                </c-form>
                <c-form title="联系方式">
                    <c-form-column>
                        <c-form-item type="editor" label="" name="contact_info" required></c-form-item>
                    </c-form-column>
                </c-form>
            </c-form>
            <template slot="button">
                <c-button size="m" @click="save()">保存</c-button>
            </template>
        </module>
    </page>
</template>

<script>
export default {
    name: 'm_about',

    props: {
        languageType: Number        //2=英文  1=中文
    },

    watch:{
        languageType(){
            this.title == (this.languageType==2?'英文':'中文')+'关于阿尔塔';
        }
    },

    data() {
        return {
            title:'关于阿尔塔'
        }
    },

    mounted() {
        this.getDetail();
    },

    methods: {
        getDetail() {
            this.request({
                url: this.languageType==2?'/website/about_en/base/detail':'/website/about/base/detail',
                data: {},
                loading: true,
                success: data => {
                    if (data){
                        var formObj = JSON.parse(data);
                        this.$refs.editForm.set(formObj);
                    }
                }
            });
        },

        save() {
            this.$refs.editForm.submit({
                url: this.languageType==2?'/website/about_en/base/edit':'/website/about/base/edit',
                rule: {
                    video:'请上介绍视频',
                    remark:'请填写公司简介',
                    product_count:'请输入【研发产品种类】数量',
                    product_count_unit:'请输入【研发产品种类】单位',
                    production_capacity:'请输入【生产能力】',
                    production_capacity_unit:'请输入【生产能力】单位',
                    preparation_capacity:'请输入【标准溶液制备能力】',
                    preparation_capacity_unit:'请输入【标准溶液制备能力】单位',
                    patent_count:'请输入【申请发明专利】数量',
                    patent_count_unit:'请输入【申请发明专利】单位',
                    contact_info:'请输入【联系方式】信息'
                },

                dataFormatter: data => {
                    var submitObj = {};
                    submitObj.control_configure = JSON.stringify(data)
                    return submitObj;
                },
                success: () => {
                    this.$message({
                        text: '保存成功',
                        icon: 'success'
                    });
                }
            });
        },
    }
}
</script>

<style lang="stylus" scoped>
.invoice-list {
    .item {
        box-sizing: border-box;
        width: 360px;
        height: 360px;
        padding: 10px 15px;
        margin-right: 26px;
        margin-bottom: 26px;
        background: #F9F9F9;

        p {
            padding: 5px 0;
            line-height: 20px;
            font-size: 13px;
            color: #333;
        }

        .handle {
            margin-top: 20px;
            text-align: right;

            a {
                margin-left: 15px;
                font-size: 16px;
                color: #666;
            }
        }
    }

    .add {
        box-sizing: border-box;
        width: 360px;
        height: 360px;
        border: 1px dashed #ddd;
        font-size: 50px;
        color: #ccc;
        cursor: pointer;

        &:hover {
        theme-border(main);
        theme-color(main);
        }
    }
}
</style>